const ACTION_DEFINITIONS = [
  {
    key: "move-my-body",
    displayLabel: "Move my body",
    shortLabel: "Move my body",
    assetBaseName: "Move my body",
    category: "green",
  },
  {
    key: "smile-big",
    displayLabel: "Smile big",
    shortLabel: "Smile big",
    assetBaseName: "Smile big",
    category: "green",
  },
  {
    key: "stretch",
    displayLabel: "Stretch",
    shortLabel: "Stretch",
    assetBaseName: "Stretch",
    category: "green",
  },
  {
    key: "be-mindful",
    displayLabel: "Be mindful. Be where my feet are",
    shortLabel: "Be mindful",
    assetBaseName: "Be mindful. Be where my feet are",
    category: "green",
  },
  {
    key: "help-others",
    displayLabel: "Help Others",
    shortLabel: "Help Others",
    assetBaseName: "Help Others",
    category: "green",
    aliases: ["help others"],
  },
  {
    key: "gratitude",
    displayLabel: "Think of 3 things that I am grateful for",
    shortLabel: "Practice gratitude",
    assetBaseName: "Think of 3 things that I am grateful for",
    category: "green",
    aliases: [
      "think of three things i am grateful for",
      "think of three things that i am grateful for",
    ],
  },
  {
    key: "give-someone-a-compliment",
    displayLabel: "Give someone a compliment",
    shortLabel: "Give someone a compliment",
    assetBaseName: "Give someone a compliment",
    category: "green",
  },
  {
    key: "give-someone-a-high-five",
    displayLabel: "Give someone a high five",
    shortLabel: "Give someone a high five",
    assetBaseName: "Give someone a high five",
    category: "green",
    aliases: ["give someone a high five"],
  },
  {
    key: "write-in-my-journal",
    displayLabel: "Write in my journal",
    shortLabel: "Write in my journal",
    assetBaseName: "Write in my journal",
    category: "green",
    aliases: ["write in my journal"],
  },
  {
    key: "create-art",
    displayLabel: "Create art",
    shortLabel: "Create art",
    assetBaseName: "Create art",
    category: "green",
  },
  {
    key: "imagine-positive-things",
    displayLabel: "Imagine positive things in the future",
    shortLabel: "Imagine positive things",
    assetBaseName: "Imagine positive things in the future",
    category: "blue",
  },
  {
    key: "laugh-at-something-funny",
    displayLabel: "Laugh at something funny",
    shortLabel: "Laugh at something",
    assetBaseName: "Laugh at something funny",
    category: "blue",
  },
  {
    key: "remember-difficult-times-pass",
    displayLabel: "Remember that difficult times pass",
    shortLabel: "Remember difficulties pass",
    assetBaseName: "Remember that difficult times pass",
    category: "blue",
  },
  {
    key: "remind-myself-of-two-good-things",
    displayLabel: "Remind myself of two good things in my life",
    shortLabel: "Remember positives",
    assetBaseName: "Remind myself of two good things in my life",
    category: "blue",
  },
  {
    key: "tell-myself-something-nice",
    displayLabel: "Tell myself something nice",
    shortLabel: "Say nice things to myself",
    assetBaseName: "Tell myself something nice",
    category: "blue",
  },
  {
    key: "get-some-sun-in-my-eyes",
    displayLabel: "Get some sun in my eyes",
    shortLabel: "Get sun in my eyes",
    assetBaseName: "Get some sun in my eyes",
    category: "blue",
  },
  {
    key: "count-to-ten",
    displayLabel: "Count to ten taking a deep breath each time",
    shortLabel: "10 deep breaths",
    assetBaseName: "Count to ten taking a deep breath each time",
    category: "purple",
  },
  {
    key: "imagine-a-peaceful-place",
    displayLabel: "Imagine a peaceful place",
    shortLabel: "Imagine a peaceful place",
    assetBaseName: "Imagine a peaceful place",
    category: "purple",
  },
  {
    key: "listen-to-music-or-read",
    displayLabel: "Listen to music or read",
    shortLabel: "Enjoy music or reading",
    assetBaseName: "Listen to music or read",
    category: "purple",
  },
  {
    key: "politely-move-away",
    displayLabel: "Politely move away from a distraction",
    shortLabel: "Walk away calmly",
    assetBaseName: "Politely move away from a distraction",
    category: "purple",
  },
  {
    key: "squeeze-my-fist",
    displayLabel: "Squeeze my fist",
    shortLabel: "Squeeze my fist",
    assetBaseName: "Squeeze my fist",
    category: "purple",
  },
  {
    key: "use-my-growth-mindset",
    displayLabel: "Use my growth mindset",
    shortLabel: "Use growth mindset",
    assetBaseName: "Use my growth mindset",
    category: "purple",
  },
];

export const backgroundColors = {
  green: "#4CC68D",
  blue: "#5B9BD5",
  purple: "#BD92E4",
};

const normalizeActionValue = (value) =>
  typeof value === "string"
    ? value.trim().replace(/\s+/g, " ").toLowerCase()
    : "";

const toFallbackDisplayLabel = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return "";
  }

  return trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1);
};

const buildAction = (action) => {
  const aliases = [
    action.displayLabel,
    action.assetBaseName,
    ...(action.aliases ?? []),
  ];

  return Object.freeze({
    ...action,
    aliases,
  });
};

export const WELLNESS_ACTIONS = ACTION_DEFINITIONS.map(buildAction);

const ACTIONS_BY_ALIAS = new Map();

for (const action of WELLNESS_ACTIONS) {
  action.aliases.forEach((alias) => {
    const normalizedAlias = normalizeActionValue(alias);

    if (normalizedAlias) {
      ACTIONS_BY_ALIAS.set(normalizedAlias, action);
    }
  });
}

export const categorizedPractices = WELLNESS_ACTIONS.reduce(
  (allPractices, action) => {
    allPractices[action.category].push(action.displayLabel);
    return allPractices;
  },
  {
    green: [],
    blue: [],
    purple: [],
  },
);

export const ALL_ACTIONS = WELLNESS_ACTIONS.map(
  (action) => action.displayLabel,
);

export function isOtherWellnessAction(rawAction) {
  const normalizedAction = normalizeActionValue(rawAction);
  return normalizedAction.startsWith("other");
}

export function getOtherWellnessActionText(rawAction) {
  if (!isOtherWellnessAction(rawAction)) {
    return "";
  }
  return String(rawAction)
    .trim()
    .replace(/^other\s*:?\s*/i, "")
    .trim();
}

export function capitalizeFirstLetterOfEachSentence(text) {
  if (typeof text !== "string") {
    return "";
  }

  return formatActionTextForSentence(text).replace(
    /(^|[.!?]\s+)([a-z])/g,
    (match, sentenceStart, firstChar) => {
      return `${sentenceStart}${firstChar.toUpperCase()}`;
    },
  );
}

export function formatActionTextForSentence(text) {
  if (typeof text !== "string") {
    return "";
  }

  return text
    .trim()
    .replace(/([.!?]\s+)([a-z])/g, (match, sentenceStart, firstChar) => {
      return `${sentenceStart}${firstChar.toUpperCase()}`;
    })
    .replace(/\bi(?=\b|['\u2019])/g, "I");
}

export function getFormattedOtherWellnessActionText(rawAction) {
  return capitalizeFirstLetterOfEachSentence(
    getOtherWellnessActionText(rawAction),
  );
}

export function resolveWellnessAction(rawAction) {
  const trimmedAction = typeof rawAction === "string" ? rawAction.trim() : "";

  if (!trimmedAction) {
    return null;
  }

  if (isOtherWellnessAction(trimmedAction)) {
    return {
      key: "other",
      rawAction: trimmedAction,
      displayLabel: "Other",
      shortLabel: "Other",
      assetBaseName: "Other",
      category: "green",
      isKnown: true,
      isOther: true,
      otherText: getOtherWellnessActionText(trimmedAction),
    };
  }

  const resolvedAction = ACTIONS_BY_ALIAS.get(
    normalizeActionValue(trimmedAction),
  );

  if (resolvedAction) {
    return {
      ...resolvedAction,
      rawAction: trimmedAction,
      isKnown: true,
      isOther: false,
      otherText: "",
    };
  }

  const fallbackDisplayLabel = toFallbackDisplayLabel(trimmedAction);

  return {
    key: normalizeActionValue(trimmedAction) || trimmedAction,
    rawAction: trimmedAction,
    displayLabel: fallbackDisplayLabel,
    shortLabel: fallbackDisplayLabel,
    assetBaseName: null,
    category: null,
    isKnown: false,
    isOther: false,
    otherText: "",
  };
}

export function getWellnessActionDisplay(rawAction, options = {}) {
  const { variant = "default" } = options;
  const resolvedAction = resolveWellnessAction(rawAction);

  if (!resolvedAction) {
    return "";
  }

  if (variant === "short") {
    return resolvedAction.shortLabel;
  }

  return resolvedAction.displayLabel;
}

export function getWellnessActionCategory(rawAction) {
  const resolvedAction = resolveWellnessAction(rawAction);
  return resolvedAction?.category ?? null;
}

export function getWellnessActionBackgroundColor(rawAction, fallback = null) {
  const actionCategory = getWellnessActionCategory(rawAction);
  return actionCategory ? backgroundColors[actionCategory] : fallback;
}

export function getWellnessActionImageFilename(rawAction, options = {}) {
  const { adultActionImages = false, variant = "circle" } = options;
  const resolvedAction = resolveWellnessAction(rawAction);

  if (variant === "plain") {
    return resolvedAction?.isOther
      ? "other.png"
      : resolvedAction?.assetBaseName
        ? `${resolvedAction.assetBaseName}.png`
        : "other.png";
  }

  const imageModifier = adultActionImages
    ? "AdultCircle_BIG_FONT"
    : "TeenCircle_BIG_FONT";

  return resolvedAction?.isOther
    ? "Other_BIG_FONT.png"
    : resolvedAction?.assetBaseName
      ? `${resolvedAction.assetBaseName} ${imageModifier}.png`
      : "Other_BIG_FONT.png";
}

export function getWellnessActionImageSrc(rawAction, options = {}) {
  const { basePath, variant = "circle" } = options;
  const normalizedBasePath =
    basePath ?? (variant === "plain" ? "/images/actions" : "../images/actions");

  return `${normalizedBasePath}/${getWellnessActionImageFilename(
    rawAction,
    options,
  )}`;
}
